import { useValidatePhoneNumber } from '../hooks/useValidatePhoneNumber'

import * as OrderTexts from '../../../../../../../../intl'
import { form } from '../../../../../formState'
import { Props } from '../../../typings'

export function Phone(props: Props) {
  const { orderStepType, notificationBehavior, initialValues } = props

  const validatePhoneNumber = useValidatePhoneNumber()

  const fieldNamePhone = `${orderStepType}.phone` as 'pickup.phone' | 'delivery.phone'

  form.useAddFieldValidation<typeof fieldNamePhone>(fieldNamePhone, async (field, _formApi) => {
    const phone = field.value

    if (notificationBehavior !== 'NO_NOTIFICATIONS') {
      if (notificationBehavior === 'EMAIL_AND_PHONE') {
        if (phone && phone.length > 0) {
          const phoneFieldPristine = phone === initialValues.orderStep.phone
          const skipPhoneValidation = phoneFieldPristine

          const phoneIsValid = skipPhoneValidation ? true : await validatePhoneNumber(phone)

          if (!phoneIsValid) {
            return OrderTexts.getValidationErrorPhoneText()
          }
        }
      }
    }
  })

  return (
    <form.TextField
      label={OrderTexts.getFieldLabelPhoneText()}
      name={`${orderStepType}.phone`}
      testId="phone"
      validateOn="blur"
    />
  )
}
